import { QueryFunctionContext } from '@tanstack/react-query';
import { ConsolidationConfigurationService } from 'src/services/ConsolidationConfigurationService';

export const QUERY_KEY = 'consolidationConfig';

export const queryConsolidationConfiguration = async (
    context: QueryFunctionContext<App.ConsolidationConfiguration.QueryKey>,
): Promise<Models.IngestConfigApi.ConsolidationConfiguration | null> => {
    const { queryKey } = context;
    const [, accessToken, productKey] = queryKey;

    return ConsolidationConfigurationService.getConsolidationConfiguration(
        accessToken,
        productKey,
    );
};
